import InputAdornment from '@mui/material/InputAdornment'
import React from 'react'
import { NumericFormat, type NumericFormatProps } from 'react-number-format'

import HHTextField from './HHTextField'

type HHNumberFieldProps = NumericFormatProps<React.ComponentProps<typeof HHTextField>> & {
  dollarPrefix?: boolean
  InputProps?: Record<string, unknown>
}

const HHNumberField: React.FC<HHNumberFieldProps> = ({ dollarPrefix = false, InputProps, ...rest }) => (
  <NumericFormat
    customInput={HHTextField}
    {...rest}
    InputProps={{ startAdornment: dollarPrefix && <InputAdornment position="start">$</InputAdornment>, ...InputProps }}
  />
)

export default HHNumberField
